__turbopack_context__.v({
  "logoBackground": "CarouselStudioBranding-module-scss-module__nQc4oG__logoBackground",
});
